import React from 'react';

import styles from './SubmitLeveler.module.css';

interface ISubmitLevelerProps {
  children: React.ReactNode,
}

const SubmitLeveler = ({ children }: ISubmitLevelerProps) => (
  <div className={styles.grid}>
    <div className={styles.submit}>{children}</div>
  </div>
);

export default SubmitLeveler;
